// Instellingen · Meldingen in de ouderapp (0038_meldingen; docs/DESIGN.md §8.PU). Rustig, je-vorm,
// korte zinnen, werkwoorden op knoppen. De teksten van de meldingen zelf staan in push.nl.ts
// (alleen de server).
export const appPushNl = {
    title: 'Meldingen',
    subtitle: 'Seintjes op je telefoon. Jij kiest wat je krijgt.',
    settingsBody: 'Herinneringen, ritten en berichten op je telefoon',
    // ---- Deze telefoon --------------------------------------------------------------------------
    device: {
        title: 'Op dit toestel',
        on: 'Meldingen staan aan op dit toestel.',
        off: 'Meldingen staan nog uit op dit toestel.',
        turnOn: 'Zet meldingen aan',
        turnOff: 'Zet uit op dit toestel',
        test: 'Stuur een proefmelding',
        testSent: 'Proefmelding verstuurd. Hij komt zo binnen.',
        testNone: 'Er is nog geen telefoon aangemeld.',
        testOff: 'Versturen staat uit op deze server.',
        turnedOn: 'Meldingen staan aan',
        turnedOff: 'Meldingen staan uit op dit toestel',
        denied: 'Je browser blokkeert meldingen van AMUMIN. Zet ze aan bij de instellingen van je browser of telefoon en kom dan terug.',
        unsupported: 'Deze browser kan geen meldingen ontvangen.',
        nativeApp: 'In de iPhone-app van AMUMIN komen nog geen meldingen binnen. Wil je ze nu al? Open AMUMIN dan in Safari en zet hem op je beginscherm.',
        unavailable: 'Meldingen zijn nog niet ingesteld. Probeer het later nog eens.',
        needsInstall: 'Op iPhone en iPad komen meldingen alleen binnen als AMUMIN op je beginscherm staat. Zet hem daar eerst neer (zie hieronder) en open AMUMIN dan vanaf je beginscherm.',
        notAllowedChild: 'Een ouder zet meldingen voor jou aan.',
        inUse: 'Deze browser is al aangemeld voor iemand anders in jullie gezin.',
        /** Aan op dit toestel, maar elke soort staat uit. */
        nothingChosen: 'Je hebt niets gekozen, er komen geen meldingen.',
        loginNote: 'Meldingen komen zolang je op dit toestel ingelogd bent. Log je uit, dan stoppen ze.',
    },
    // ---- Zet AMUMIN op je beginscherm -----------------------------------------------------------
    install: {
        title: 'Zet AMUMIN op je beginscherm',
        body: 'Dan open je AMUMIN met één tik, net als een app. Het kost niets en je hoeft niets te downloaden.',
        installed: 'AMUMIN staat op je beginscherm.',
        platform: 'Welk toestel?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        iosNote: 'Meldingen werken vanaf iOS 16.4, als AMUMIN op je beginscherm staat.',
        androidButton: 'Installeer AMUMIN',
        desktopButton: 'Installeer AMUMIN',
    },
    // ---- Wat wil je krijgen? --------------------------------------------------------------------
    kinds: {
        title: 'Wat wil je krijgen?',
        autosave: 'Wat je aanvinkt, wordt meteen bewaard.',
        reminders: 'Mijn herinneringen',
        remindersHint: 'Op hetzelfde moment als de tablet roept.',
        remindersChildren: 'Ook de herinneringen van mijn kinderen',
        rides: 'Ritten',
        ridesHint: '"Wie brengt Yakub morgen om 08:15?" en wie een rit overneemt.',
        approvals: 'Wat op mijn ja wacht',
        approvalsHint: 'Samen in één melding, hooguit één keer per half uur.',
        messages: 'Nieuwe berichten',
        departure: 'Tijd om te vertrekken',
        departureHint: 'Als er een reistijd bij de afspraak staat.',
        summary: 'Dagoverzicht',
        summaryHint: 'Elke dag een korte samenvatting van de agenda.',
        summaryAt: 'Om',
    },
    // ---- Stille uren ---------------------------------------------------------------------------
    quiet: {
        title: 'Stille uren',
        toggle: 'Geen meldingen in de stille uren',
        from: 'Van',
        to: 'Tot',
        note: 'Herinneringen die je zelf voor jezelf maakte komen er wel door.',
    },
    // ---- Discreet ------------------------------------------------------------------------------
    discreet: {
        title: 'Discreet op het vergrendelscherm',
        body: 'Meldingen gaan versleuteld via de dienst van Apple, Google, Mozilla of Microsoft. Die kan ze niet lezen. Maar op je vergrendelscherm kan iedereen meekijken. Daarom staat er standaard alleen "AMUMIN" en wat voor melding het is.',
        all: 'Alles discreet',
        allHint: 'Standaard aan. Je ziet alleen "AMUMIN" met "Een herinnering", "Iets over brengen en halen", "Er wacht iets op je ja" of "Een nieuw bericht". Zet je dit uit, dan zie je details: de titel, namen, de tijd, de plaats en de tekst van een bericht.',
        sensitive: 'Geloof, zorg en school discreet',
        sensitiveHint: 'Ook met details aan: herkennen we aan het pictogram of aan woorden als "logopedie", "oogarts", "iftar", "suikerfeest", "rapport" of "studiedag" dat een afspraak, herinnering of bericht over zorg, geloof of school gaat, dan blijft de melding discreet. Geen woordenlijst is compleet: twijfel je, laat alles discreet.',
    },
    // ---- Kinderen ------------------------------------------------------------------------------
    children: {
        title: 'Kinderen',
        body: 'Een kind met een eigen login kan ook meldingen krijgen, als jij dat goed vindt. Standaard staat dit uit.',
        allow: 'Meldingen voor {name}',
        noLogin: '{name} heeft geen eigen login.',
        none: 'Er zijn nog geen kinderen in jullie gezin.',
        toastOn: '{name} mag nu meldingen krijgen',
        toastOff: '{name} krijgt geen meldingen meer',
    },
    // ---- Aangemelde browsers -------------------------------------------------------------------
    devices: {
        title: 'Je telefoons en browsers',
        none: 'Nog geen telefoon of browser aangemeld.',
        since: 'Aangemeld op {date}',
        lastUsed: 'Laatste melding {date}',
        error: 'De laatste melding kwam niet aan.',
        remove: 'Weghalen',
        removeLabel: '{name} weghalen',
        removed: 'Weggehaald',
        thisOne: 'Deze',
    },
    save: 'Opslaan',
    saved: 'Opgeslagen',
    offTitle: 'Meldingen staan uit',
    offBody: 'Meldingen staan uit voor jullie gezin. Een ouder zet ze aan bij Modules.',
};
//# sourceMappingURL=pushApp.nl.js.map